/* eslint-env browser */

require('../../../container/client')
